import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "section-eyebrow" }
const _hoisted_3 = { class: "section-num bg-msq-yellow" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("section", {
    id: _ctx.sectionId || undefined,
    class: _normalizeClass(["landing-section", {
      'landing-section--band': _ctx.variant === 'band' || _ctx.variant === 'band-top',
      'landing-section--band-top': _ctx.variant === 'band-top'
    }])
  }, [
    _createVNode(_component_v_container, { class: "landing-section__inner pa-0" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.meta.numeral), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.meta.eyebrow), 1)
        ]),
        (_ctx.meta.headlineHtml)
          ? (_openBlock(), _createElementBlock("h2", {
              key: 0,
              class: "section-headline",
              innerHTML: _ctx.meta.headlineHtml
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.meta.ledeHtml)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: "section-lede text-medium-emphasis",
              innerHTML: _ctx.meta.ledeHtml
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    })
  ], 10, _hoisted_1))
}